import { OperatorUserWorkOrderTaskPermissionName } from '@xbcb/client-types';
import { AnyObject } from '@xbcb/shared-types';
import { safeGetMessage } from '@xbcb/ui-utils';
import { WorkOrderTaskStatus } from '@xbcb/work-order-types';
import { setModal } from 'actions';
import { ModalKey } from 'types';
import getQueryParameters from 'libs/getQueryParameters';
import { AppRecordKebabMenuItem } from '../../types';

export const appRecordAssignWorkOrderTaskMenuItem: AppRecordKebabMenuItem = {
  text: ({ appRecordBundle }) => safeGetMessage(appRecordBundle, 'assign'),
  key: 'assign',
  action: async ({ dispatch }) => {
    dispatch(
      setModal({
        key: ModalKey.ASSIGN_WORK_ORDER_TASK,
        props: {
          visible: true,
        },
      }),
    );
  },
  show: ({ currentUser, existingRecord, location }) => {
    const { workOrderTask } = currentUser?.operatorUserPermissions || {};
    const queryParameters = getQueryParameters(location);
    const taskId = queryParameters['taskId'];
    const taskType = queryParameters['task'];
    const isAuthorized =
      Boolean(workOrderTask) &&
      workOrderTask.some(
        ({ name }: { name: string }) =>
          name === OperatorUserWorkOrderTaskPermissionName.ADMIN,
      );
    const { tasks } = existingRecord;
    const task = taskId
      ? tasks.find((task: AnyObject) => task.id === taskId)
      : tasks.find(
          (task: AnyObject) => task.definition?.workOrderTaskType === taskType,
        );
    const isActiveWorkOrderTask =
      task &&
      ![WorkOrderTaskStatus.CANCELED, WorkOrderTaskStatus.COMPLETED].includes(
        task.status,
      );
    return (taskId || taskType) && isAuthorized && isActiveWorkOrderTask;
  },
};
